module.exports = __webpack_public_path__ + "img/bg.fc6d3eeb.png";